var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_137_2",
    "data-name": "Component 137 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3265",
    "data-name": "Rectangle 3265",
    width: 40,
    height: 40,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3201",
    "data-name": "Group 3201",
    transform: "translate(4.254 1.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M19.366,32.76H2.338A2.219,2.219,0,0,1,0,30.567V2.488A2.589,2.589,0,0,1,.684.759,2.241,2.241,0,0,1,2.338,0h11.7V9.509A2.219,2.219,0,0,0,16.378,11.7h9.361V23.838H22.21V30.9H17.5l1.861,1.861ZM17.494,18.571v7.187h1.252V22.716h2.891v-1H18.746V19.58h3.314V18.571Zm-6.6,0v7.187H12.96a3.487,3.487,0,0,0,1.726-.417,2.836,2.836,0,0,0,1.157-1.2,3.806,3.806,0,0,0,.406-1.8v-.362a3.832,3.832,0,0,0-.4-1.787A2.9,2.9,0,0,0,14.7,19a3.293,3.293,0,0,0-1.688-.428Zm-6.462,0v7.187H5.678V23.092H7.162a2.955,2.955,0,0,0,1.945-.584A2.06,2.06,0,0,0,9.8,20.861,2.119,2.119,0,0,0,9.091,19.2a2.794,2.794,0,0,0-1.912-.631Zm8.523,6.193h-.813V19.58h.875a1.82,1.82,0,0,1,1.477.617A2.777,2.777,0,0,1,15,21.985v.4a2.675,2.675,0,0,1-.535,1.768A1.89,1.89,0,0,1,12.952,24.764ZM7.179,22.089h-1.5V19.58H7.213a1.355,1.355,0,0,1,.978.361,1.235,1.235,0,0,1,.352.929,1.156,1.156,0,0,1-.347.9A1.468,1.468,0,0,1,7.179,22.089ZM25.737,9.362H16.378V.149L25.735,9.36Z",
    transform: "translate(0 0)",
    fill: "#ee161f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_5",
    "data-name": "Intersection 5",
    d: "M0,7.056H3.286V0h4.93V7.056H11.5L5.751,12.808Z",
    transform: "translate(19.988 24.65)",
    fill: "#ee161f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/PdfDownload.abd9b64c3ab122f6da8bce7aa6150831.svg";
export { ForwardRef as ReactComponent };